// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ukYFg","delete":"styles_delete__l3slO","update":"styles_update__1GGNB","add":"styles_add__2rSuT"};